/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportSsrsParameter {
    getFixupPrototypeFunction() { return ReportSsrsParameter.fixupPrototype; }

    static newInstance(model: Partial<ReportSsrsParameter>): ReportSsrsParameter {
        let obj = Object.assign(new ReportSsrsParameter(), model);
        ReportSsrsParameter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportSsrsParameter>): ReportSsrsParameter {
        if (!model) return null;
        return ReportSsrsParameter.newInstance(<ReportSsrsParameter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportSsrsParameter) {
        if (!obj) return;

        models.ReportSsrsParameter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportSsrsParameter): boolean {
        Object.setPrototypeOf(obj, ReportSsrsParameter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SSRS report parameter name, e.g. UserID
     */
    name: string;

    /**
     * Values passed for the parameter
     */
    values: Array<string>;

}
